import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { transformMediaQuestionAttributes } from './utils';
import QuestionMedia from '../QuestionMedia';

export default function ABConceptAttributes({ question, groups }) {
  if (isEmpty(question.selectedAttributes)) {
    return null;
  }
  if (isEmpty(groups)) {
    Raven.captureMessage(
      'QuestionTemplate found question with selectedAttributes but did not found groups',
      {
        extra: {
          ...question,
        },
      },
    );
    return null;
  }
  const group = groups.find(({ refId }) => question.groupRefId === refId);
  if (isEmpty(group)) {
    Raven.captureMessage(
      'QuestionTemplate found question with selectedAttributes but is not in a question group',
      {
        extra: {
          ...question,
        },
      },
    );
    return null;
  }
  const attributes = group.getAttributesForQuestion(question.refId);
  if (isEmpty(attributes)) {
    Raven.captureMessage(
      'QuestionTemplate found question within question group but no attributes found in the group',
      {
        extra: {
          ...question,
        },
      },
    );
    return null;
  }

  const attributeTemplate = [];
  attributes.forEach((attribute) => {
    if (attribute.text) {
      attributeTemplate.push(
        <div
          key={attribute.refId}
          className="text-center margin-lg-btm ab-attribute-label"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: attribute.text }}
        ></div>,
      );
    }
    if (attribute.media || attribute.image_url || attribute.video) {
      const mediaAttributes = transformMediaQuestionAttributes({
        ...attribute,
        questionRefId: question.refId,
      });
      attributeTemplate.push(
        <QuestionMedia key={`media-${attribute.refId}`} {...mediaAttributes} />,
      );
    }

    if (attribute.video) {
      if (!question.conceptVideos) {
        // NOTE: i am not making any changes to current code apart from refactoring it into react.
        // this side effect should be removed in the future
        // eslint-disable-next-line no-param-reassign
        question.conceptVideos = [];
      }
      question.conceptVideos.push(attribute.video);
    }
  });
  return attributeTemplate;
}

ABConceptAttributes.propTypes = {
  question: PropTypes.object,
  groups: PropTypes.array,
};
